const entryListLength = (entryList) => {
  if (!entryList) return 0;
  return Array.isArray(entryList) ? entryList.length : 1;
};

/**
 * Count entries shown in the reconcile sidebar "Asientos" tab badge for a document:
 * emission on the document + matchEntry refs on inMatch/outMatch.
 */
export const countDocumentReconcileEntries = (document) => {
  if (!document) return 0;

  let count = entryListLength(document.entries?.entryList);

  for (const match of [
    ...(document.meta?.matchs?.inMatch || []),
    ...(document.meta?.matchs?.outMatch || []),
  ]) {
    count += entryListLength(match?.entries?.entryList);
  }

  return count;
};

/** Count entries for a transaction sidebar: movement entries + matchEntry refs on matchs. */
export const countTransactionReconcileEntries = (transaction) => {
  if (!transaction) return 0;

  let count = entryListLength(transaction.entries?.entryList);

  for (const match of transaction.matchs || []) {
    count += entryListLength(match?.entries?.entryList);
  }

  return count;
};
